"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var styled_components_1 = __importDefault(require("styled-components"));
var VisibilityOffOutlined_1 = __importDefault(require("../Icon/icons/VisibilityOffOutlined"));
var VisibilityOff_1 = __importDefault(require("../Icon/icons/VisibilityOff"));
var Utility_1 = require("../Utility");
var StyledDivButton = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  > svg {\n    height: 100%;\n    width: 100%;\n  }\n"], ["\n  > svg {\n    height: 100%;\n    width: 100%;\n  }\n"])));
var TextInput = function (props) {
    var _a = (0, Utility_1.handleUtility)(props), inputRef = _a.inputRef, label = _a.label, info = _a.info, type = _a.type, error = _a.error, isStatic = _a.isStatic, isSearch = _a.isSearch, isValidation = _a.isValidation, inProgress = _a.inProgress, children = _a.children, className = _a.className, rest = __rest(_a, ["inputRef", "label", "info", "type", "error", "isStatic", "isSearch", "isValidation", "inProgress", "children", "className"]);
    var isPassword = type === 'password';
    var _b = (0, react_1.useState)(isPassword), hide = _b[0], setHide = _b[1];
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('t2-input-text', className, {
            't2-in-progress': inProgress,
            't2-error': error,
            't2-input-password': isPassword,
            't2-input-search': isSearch,
            't2-validation': isValidation,
        }) },
        react_1.default.createElement("input", __assign({ role: 'textbox', ref: inputRef, type: !hide && isPassword ? 'text' : type, placeholder: isStatic ? undefined : '-', disabled: inProgress }, rest)),
        label && react_1.default.createElement("label", null, label),
        info && react_1.default.createElement("span", { className: "t2-input-info-label" }, info),
        isPassword && (react_1.default.createElement(StyledDivButton, { role: "button", className: "t2-icon", onClick: function () { return setHide(!hide); } }, hide ? react_1.default.createElement(VisibilityOff_1.default, null) : react_1.default.createElement(VisibilityOffOutlined_1.default, null))),
        children));
};
exports.default = TextInput;
var templateObject_1;
